var _path, _path2, _circle, _path3, _path4, _circle2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalentButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98024 14.1328C5.33783 14.1328 6.24074 12.6866 6.29673 11.3301C6.34911 10.0612 6.39798 8.75326 6.39798 7.41686C6.39798 6.08046 6.34911 4.77253 6.29673 3.50358C6.24075 2.14714 5.33783 0.700911 3.98024 0.700911C2.62265 0.700911 1.71974 2.14714 1.66375 3.50358C1.61137 4.77252 1.5625 6.08046 1.5625 7.41686C1.5625 8.75326 1.61137 10.0612 1.66375 11.3301C1.71974 12.6866 2.62265 14.1328 3.98024 14.1328Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63989 6.88579C6.63989 7.75521 6.65717 8.84349 6.66477 9.90199C6.67596 11.4614 5.38428 12.7166 3.82488 12.7014V12.7014C2.26549 12.6862 1.28439 11.4615 1.31718 9.90238C1.36192 7.77502 1.51806 5.47428 1.64222 3.36673C1.72039 2.03976 2.65783 0.707111 3.98709 0.707111V0.707111V0.707111C5.31636 0.707111 6.32149 2.03523 6.42491 3.36046C6.43058 3.43313 6.43518 3.50055 6.43841 3.5614",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.98326,
    cy: 11.4208,
    r: 2.68638,
    fill: "#0C0C0C",
    stroke: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0119 14.1328C10.6544 14.1328 9.75144 12.6866 9.69545 11.3301C9.64308 10.0612 9.5942 8.75326 9.5942 7.41686C9.5942 6.08046 9.64308 4.77253 9.69545 3.50358C9.75144 2.14714 10.6544 0.700911 12.0119 0.700911C13.3695 0.700911 14.2724 2.14714 14.3284 3.50358C14.3808 4.77252 14.4297 6.08046 14.4297 7.41686C14.4297 8.75326 14.3808 10.0612 14.3284 11.3301C14.2724 12.6866 13.3695 14.1328 12.0119 14.1328Z",
    fill: "#0C0C0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3523 6.88579C9.3523 7.75521 9.33502 8.84349 9.32742 9.90199C9.31622 11.4614 10.6079 12.7166 12.1673 12.7014V12.7014C13.7267 12.6862 14.7078 11.4615 14.675 9.90238C14.6303 7.77502 14.4741 5.47428 14.35 3.36673C14.2718 2.03976 13.3344 0.707111 12.0051 0.707111V0.707111V0.707111C10.6758 0.707111 9.6707 2.03523 9.56728 3.36046C9.56161 3.43313 9.55701 3.50055 9.55377 3.5614",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.68638,
    cy: 2.68638,
    r: 2.68638,
    transform: "matrix(-1 0 0 1 14.6953 8.73438)",
    fill: "#0C0C0C",
    stroke: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6718 4.45008C8.83894 3.22497 7.10632 3.22497 5.27344 4.45008",
    stroke: "#FAFAFA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentButton);
export default __webpack_public_path__ + "static/media/talent-button.ef6ab0e16980c1fd08ab83f0d8907649.svg";
export { ForwardRef as ReactComponent };